import { KyJson } from '@eaphone/network';

export function getStatus({ serial }) {
  return KyJson.get(`organization/v1/device/serial/${serial}/status`);
}
